import { Checkbox } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import {
  CollaboratorAccessConfig,
  ResourceManagementConfig,
} from 'api/resource-management/types';
import { Loading } from 'components/atoms/loading';
import { useTranslation } from 'hooks/use-translation';
// eslint-disable-next-line import/no-internal-modules
import { SettingToggleTitle } from '../soft-allocation-settings/components';

const StyledSection = styled.section`
  display: flex;
`;

interface Props {
  isConfigLoading: boolean;
  initialConfig?: ResourceManagementConfig;
  handleCollaboratorAccessChange: (
    collaboratorAccessConfiguration: CollaboratorAccessConfig,
  ) => void;
}

export const CollaboratorAccessSettings: FC<Props> = ({
  isConfigLoading,
  initialConfig,
  handleCollaboratorAccessChange,
}) => {
  const toggleCollaboratorAccess = (checked: boolean) => {
    if (initialConfig == null) {
      return;
    }

    handleCollaboratorAccessChange({
      hasViewAccess: checked,
      hasEditAccess: checked,
    });
  };

  return (
    <StyledSection>
      {isConfigLoading ? (
        <Loading />
      ) : (
        <Checkbox
          checked={
            initialConfig?.accessConfig?.collaboratorAccessMeta
              ?.hasViewAccess ?? false
          }
          onChange={(e) => toggleCollaboratorAccess(e.target.checked)}
          data-cy="settings.resource-management.soft-allocations.switch"
        />
      )}
      <SettingToggleTitle
        primaryTitle={useTranslation(
          'settings.resource_management.enable_for_collaborators.title',
        )}
        secondaryTitle={useTranslation(
          'settings.resource_management.enable_for_collaborators.description',
        )}
      />
    </StyledSection>
  );
};
